import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const tabSectionItemDefinition: ComponentDefinition = {
  id: 'tabSectionItem',
  name: 'Tab Section - Item',
  category: 'Custom',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/square.svg',
  // Allow dropping child components (e.g. the Link component) into the tab content.
  children: true,
  variables: {
    title: {
      type: 'Text',
      displayName: 'Title',
      validations: { bindingSourceType: ['manual', 'experience', 'entry', 'asset'] },
    },
    description: {
      type: 'Text',
      displayName: 'Description',
      validations: { bindingSourceType: ['manual', 'experience', 'entry', 'asset'] },
    },
    icon: {
      type: 'Media',
      displayName: 'Icon (SVG)',
      validations: { bindingSourceType: ['asset'] },
    },
    image: {
      type: 'Media',
      displayName: 'Image',
      validations: { bindingSourceType: ['asset'] },
    },
    imageAspectRatio: {
      type: 'Text',
      displayName: 'Image Aspect Ratio',
      defaultValue: '1:1',
      group: 'style',
      validations: {
        in: [
          { value: '1:1', displayName: '1:1 (Square)' },
          { value: '4:5', displayName: '4:5 (Portrait)' },
          { value: '16:9', displayName: '16:9 (Landscape)' },
        ],
      },
    },
    imageFit: {
      type: 'Text',
      displayName: 'Image Fit',
      defaultValue: 'contain',
      group: 'style',
      validations: {
        in: [
          { value: 'contain', displayName: 'Contain (show full image)' },
          { value: 'cover', displayName: 'Cover (crop to fill)' },
        ],
      },
    },
    ctaLabel: {
      type: 'Text',
      displayName: 'CTA Label',
      validations: { bindingSourceType: ['manual', 'experience', 'entry', 'asset'] },
    },
    ctaUrl: {
      type: 'Text',
      displayName: 'CTA URL',
      validations: { bindingSourceType: ['manual', 'experience', 'entry', 'asset'] },
    },
  },
} as const;
